import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';
import Api, { exceptionNotificationAPI } from '../../services/api';

const INITIAL_FILTERS = { isActive: true };

const UserIndex = () => {
    const navigate = useNavigate();
    const [cultureOptions, setCultureOptions] = useState([
        { value: '', label: 'All' }
    ]);

    useEffect(() => {
        Api.get('Culture/GetAllCultures')
            .then((result) => {
                const options = result.data.response
                    .map(culture => ({
                        value: culture.cultureID,
                        label: culture.cultureDisplayName
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                setCultureOptions([{ value: '', label: 'All' }, ...options]);
            })
            .catch(exceptionNotificationAPI);
    }, []);

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "userName",
            label: "Username",
            placeholder: "Search by username..."
        },
        {
            type: "text",
            name: "email",
            label: "Email",
            placeholder: "Search by email..."
        },
        {
            type: "text",
            name: "companyName",
            label: "Supplier",
            placeholder: "Search by supplier..."
        },
        {
            type: "select",
            name: "cultureID",
            label: "Report",
            options: cultureOptions
        },
        {
            type: "select",
            name: "isActive",
            label: "Active",
            options: [
                { value: '', label: 'All' },
                { value: true, label: 'Yes' },
                { value: false, label: 'No' }
            ]
        }
    ], [cultureOptions]);

    const columns = useMemo(() => [
        { 
            title: 'Username', 
            dataIndex: 'userName', 
            key: 'userName', 
            width: '12%',
            sortable: true 
        },
        { 
            title: 'Fullname', 
            dataIndex: 'fullName', 
            key: 'fullName', 
            width: '13%',
            sortable: true 
        },
        { 
            title: 'Email', 
            dataIndex: 'email', 
            key: 'email', 
            width: '18%',
            sortable: true 
        },
        { 
            title: 'Supplier', 
            dataIndex: 'company.name', 
            key: 'company.name', 
            width: '12%',
            sortable: true 
        },
        {
            title: 'Report',
            dataIndex: 'cultures',
            key: 'cultures',
            width: '8%',
            sortable: true,
            render: (cultures) => cultures
                ?.map(culture => culture.description)
                .filter(Boolean)
                .join(', ') || '-'
        },
        { 
            title: 'Group', 
            dataIndex: 'groups.name', 
            key: 'groups.name', 
            width: '8%',
            sortable: true 
        },
        { 
            title: 'Role', 
            dataIndex: 'role.name', 
            key: 'role.name', 
            width: '12%',
            sortable: false 
        },
        {
            title: 'Inactivated By',
            dataIndex: 'inactivatedBy',
            key: 'inactivatedBy',
            width: '7%',
            sortable: false,
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: '6%',
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        }
    ], []);

    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/user/edit/${record.id}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="User"
            apiEndpoint="/User/getAllPaginated"
            toggleActiveEndpoint="/User/toggleActive"
            newRoute="/user/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="id"
            initialPageSize={10}
            initialFilters={INITIAL_FILTERS}
            fitToContainer={true}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default UserIndex;
